// import './Authorize.css';
import { Transition } from '@headlessui/react';
import OIDCButton from '../components/OIDCButton';
import { Settings } from '../Settings';
import clsx from 'clsx';
import Text from '../components/common/Text';

// This is most likely unnecessary? No SSR involved?
const safeWindow = typeof window === "undefined" ? undefined
  : window

const isNativeIOS = navigator.userAgent
  ?.split(" ")
  ?.some(comment => comment === "Eternity/iOS")

function filterIDP(idp: typeof Settings.idps[number]) {
  /**
   * Temporary fix until we can get Google Auth to work correctly with
   * the native iOS app.
   */
  if (isNativeIOS && idp.id === "google") {
    return false
  }

  return true
}

export type AuthorizePageProps = {
} & React.HTMLAttributes<HTMLDivElement>

function AuthorizePage({
  className,
  ...rest
}: AuthorizePageProps) {
  console.info("Settings:", Settings)
  return (
    <div className={clsx(className, "relative h-full w-full overflow-hidden scrollbar-hide")} {...rest}>
      <Transition
        show
        appear
        className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none overflow-hidden scrollbar-hide transition transform-gpu"
        enter="duration-[1200ms] ease-linear"
        enterFrom="brightness-0 scale-150 -translate-x-6 md:-translate-x-12 -translate-y-12 md:-translate-y-24"
        enterTo="brightness-100 scale-100 translate-x-0 translate-y-0"
      >
        <img src="/LoginScreen_Background.webp"
          className='w-full h-full object-cover'
          alt=""
        />
      </Transition>

      <Transition
        show
        appear
        className="absolute top-0 left-0 w-full h-full z-[1] pointer-events-none transition transform-gpu"
        enter="duration-[1200ms] ease-linear"
        enterFrom="brightness-0 scale-150 -translate-x-12 md:-translate-x-24 -translate-y-24 md:-translate-y-48"
        enterTo="brightness-100 scale-100 translate-x-0 translate-y-0"
      >
        <img src="/LoginScreen_Islands.webp"
          className='w-1/2 h-1/2 object-contain'
          alt=""
        />
      </Transition>

      <Transition
        show
        appear
        className="absolute top-0 left-0 w-full h-full z-[2] pointer-events-none transition transform-gpu"
        enter="duration-[1200ms] ease-linear"
        enterFrom="brightness-0 -translate-y-12 md:-translate-y-24"
        enterTo="brightness-100 translate-y-0"
      >
        <img src="/LoginScreen_LightRays.webp"
          className='w-full  object-contain animate-lightflicker'
          alt=""
        />
      </Transition>

      <Transition
        show
        appear
        className="absolute top-0 left-0 w-full h-full z-[3] pointer-events-none overflow-hidden scrollbar-hide select-none transition transform-gpu"
        enter="duration-[1200ms] ease-linear"
        enterFrom="brightness-0 scale-150 translate-x-24 md:translate-x-32 translate-y-12 md:translate-y-24"
        enterTo="brightness-100 scale-100 translate-x-0 md:translate-x-6 translate-y-0"
      >
        <img src="/LoginScreen_Character.webp"
          className='w-full h-full object-cover origin-bottom-right'
          alt=""
        />
      </Transition>

      <Transition
        show
        appear
        className="absolute top-0 left-0 w-full h-full z-[4] brightness-50 bg-black bg-opacity-60 transition transform-gpu "
        enter="delay-[1600ms] duration-300 ease-linear"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      />

      <div className='relative z-10 flex flex-col h-full justify-center items-center overflow-y-auto gap-6'>
        <Transition
          show
          appear
          className="transition transform-gpu"
          enter="delay-[1300ms] duration-200 ease-linear"
          enterFrom="opacity-0"
          enterTo="opacity-100"
        >
          <Transition.Child
            enter="delay-[1500ms] duration-500 ease-out"
            enterFrom="translate-y-12"
            enterTo="translate-y-0"
          >
            <img
              className="max-w-container-xs sm:max-w-[232px] md:max-w-container-sm lg:max-w-xl mx-auto mb-2"
              src="/logo.webp"
              alt="Eternity logo"
            />
          </Transition.Child>
          <Transition.Child
            className="flex flex-col items-center md:mt-4 lg:mt-12 gap-2"
            enter="delay-[1800ms] duration-500 ease-out"
            enterFrom="opacity-0"
            enterTo="opacity-100"
          >
            <Text className='text-white font-bold'>Choose your preferred sign in method</Text>
            <div className="flex flex-wrap gap-2 justify-center items-center ">
              {Settings.idps
                .filter(filterIDP)
                .map(idp => (
                  <OIDCButton
                    key={idp.id}
                    providerId={idp.id}
                    providerName={idp.name}
                    authorizationEndpoint={idp.authorizationEndpoint}
                    redirectUri={idp.authorizeRedirectUri}
                    clientId={idp.clientId}
                    scopes={idp.scopes}
                  />
                ))}
            </div>

            <a
              className="text-white text-lg md:text-xl underline py-0 sm:py-2"
              href={Settings.privacyUri}
              target="_blank"
              rel="noreferrer" >
              Our Privacy Policy
            </a>
          </Transition.Child>

        </Transition>
      </div>
    </div>
  );
}

export default AuthorizePage